import { useState, useEffect } from "react";
import { Chat, ChatLoading, ChatNoKey } from "../features/chat";
import { Providers } from "./providers";

function App() {
  const [isEmbedded, setIsEmbedded] = useState<boolean>(true);
  const [functionKey, setFunctionKey] = useState<string>("");
  const [username, setUsername] = useState<string>("");

  useEffect(() => {
    setIsEmbedded(window.self !== window.top);
    const params = new URLSearchParams(window.location.search);
    const functionKeyValue = params.get("functionKey");
    if (functionKeyValue) {
      setFunctionKey(functionKeyValue);
    }
    const usernameValue = params.get("username");
    if (usernameValue) {
      setUsername(usernameValue.toLowerCase());
    }
  }, []);

  if (isEmbedded && functionKey) {
    return (
      <Providers functionKey={functionKey} username={username}>
        <Chat isEmbedded />
      </Providers>
    );
  } else if (isEmbedded && !functionKey) {
    return (
      <Providers>
        <ChatLoading />
      </Providers>
    );
  } else {
    return (
      <Providers>
        <ChatNoKey />
      </Providers>
    );
  }
}

export default App;
